export enum PermissionObjectIds {
    MenuItemRole = 'MenuItem',
    ReportRole = 'Report',
    RecordRole = 'Record',
    GridViewRole = "GridView",
    ExcelDropdownReportRole = "ExcelDropdownReport",
    ExcelExportRole = "ExcelExport",
    DashboardShortcutRole = "DashboardShortcut"
}
